import React, { FC, useEffect, useState } from 'react';
import { Button, Dropdown, Grid, Modal, notification, Table } from 'antd';
import { IGetUsersProps, IUser } from '../admin-users.type';
import { deleteUser, getUsers } from '../actions';
import DotsIcon from '../../manage-reestr-item/dots.svg';
import UserRolesModal from '../user-roles';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import UserSearchFilter from '../search-forms/user-search-filter';

const UserList: FC<IGetUsersProps> = (props: IGetUsersProps) => {
    const [users, setUsers] = useState<IUser[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isAction, setIsAction] = useState<number>();
    const [isUserRolesModalOpen, setIsUserRolesModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState<any>();
    const breakpoint = Grid.useBreakpoint();
    const [pagination, setPagination] = useState<any>({
        current: 1,
        pageSize: 50,
    });
    const [filterData, setFilterData] = useState({});
    const [current, setCurrent] = useState(1);

    const items: any = [
        {
            label: 'Деактивировать',
            key: '1',
        },
        {
            label: 'Права и роли',
            key: '2',
        },
    ];

    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'ФИО',
            dataIndex: 'fio',
            key: 'fio',
            render: (_, x) => `${x.lastName} ${x.firstName}`,
        },
        {
            title: 'E-mail',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'E-mail подтвержден',
            dataIndex: 'emailConfirmed',
            key: 'emailConfirmed',
            render: (x) => (x ? 'Да' : 'Нет'),
        },
        {
            title: 'ИИН',
            dataIndex: 'taxpayerCode',
            key: 'taxpayerCode',
        },
        {
            title: 'Действия',
            dataIndex: 'id',
            key: 'actions',
            render: (id) => (
                <Dropdown
                    menu={{ items, onClick: ({ key }) => onClick(key, id) }}
                    trigger={['click']}
                >
                    <Button
                        className="p-0"
                        shape="round"
                        icon={<DotsIcon />}
                        loading={isAction === id}
                    />
                </Dropdown>
            ),
        },
    ];

    const removeUser = (id: number) => {
        Modal.confirm({
            content: 'Вы действительно хотите удалить пользователя?',
            onOk() {
                setIsAction(id);

                deleteUser(id)
                    .then(() => {
                        notification['success']({
                            message: 'Пользователь успешно удален!',
                        });
                        loadData();
                    })
                    .finally(() => setIsAction(null));
            },
        });
    };

    const userRolesModal = (id: number) => {
        setIsUserRolesModalOpen(true);
        setSelectedUser(users.find((x) => x.id === id));
    };

    const onClick = (key: string, id: number) => {
        switch (key) {
            case '1':
                removeUser(id);
                break;
            case '2':
                userRolesModal(id);
                break;
        }
    };

    const loadData = (values?: any) => {
        setIsLoading(true);

        const cleanData = values || filterData;

        const params = {
            kgdUser: false,
            page: pagination.current - 1,
            size: pagination.pageSize,
            sort: 'id,desc',
            ...cleanData,
        };

        getUsers(params)
            .then((value) => {
                setUsers(value.data.content);
                setPagination({
                    ...pagination,
                    total: value.data.totalElements,
                });
            })
            .finally(() => setIsLoading(false));
    };

    const handleOk = () => {
        loadData();
        setIsUserRolesModalOpen(false);
        setSelectedUser(null);
    };

    const handleCancel = () => {
        setIsUserRolesModalOpen(false);
        setSelectedUser(null);
    };

    const handleTableChange = (pagination: TablePaginationConfig) => {
        setPagination(pagination);
    };

    useEffect(() => {
        if (props.activeTab === props.tabKey) {
            loadData();
        }
    }, [pagination.current, props.activeTab]);

    const onClear = (values = {}) => {
        setFilterData(values);

        if (current > 1) {
            setCurrent(1);
        } else {
            loadData(values);
        }
    };

    return (
        <>
            {props.activeTab === props.tabKey && (
                <UserSearchFilter
                    {...props}
                    onSearch={loadData}
                    onClear={onClear}
                />
            )}

            <Table
                columns={columns}
                dataSource={users}
                className="my-3"
                loading={isLoading}
                pagination={{
                    ...pagination,
                    size: breakpoint.xs ? 'small' : 'default',
                    position: [breakpoint.xs ? 'bottomCenter' : 'bottomRight'],
                }}
                onChange={handleTableChange}
                scroll={{
                    x: true,
                }}
            />

            <UserRolesModal
                isModalOpen={isUserRolesModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
                selectedUser={selectedUser}
                token={props.token}
                serviceUrl={props.serviceUrl}
            />
        </>
    );
};

export default UserList;
